import moment from 'moment';
import { useTimer } from 'react-timer-hook';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';

import { getAccessTokenExpiresAt, getRefreshToken } from '@app/redux/auth/auth.selectors';
import { getBranchEnvironment } from '@app/redux/branchEnvironment/branchEnvironment.selectors';
import { useAppSelector } from '@app/redux/hooks';

function useRefreshToken() {
	const accessTokenExpiresAt = useAppSelector(getAccessTokenExpiresAt);
	const refreshToken = useAppSelector(getRefreshToken);
	const branchEnvironment = useAppSelector(getBranchEnvironment);

	const { startRequest: handleRefreshToken } = useTriggeredRequest(AccountClientRequests.Auth.refreshToken);
	const { startRequest: handleLogout } = useTriggeredRequest(AccountClientRequests.Auth.logout);

	const { restart } = useTimer({
		expiryTimestamp: moment.unix(accessTokenExpiresAt!).subtract(2, 'minutes').toDate(),
		onExpire: async () => {
			try {
				const res = await handleRefreshToken({ refresh_token: refreshToken, branch: branchEnvironment.branch_id });
				restart(moment.unix(res.login_basic.tokens.access_expires_at).subtract(2, 'minutes').toDate());
			} catch (e) {
				await handleLogout({ refresh_token: refreshToken });
			}
		},
	});
}

export default useRefreshToken;
